export default "__VITE_ASSET__B0bfl6IW__"